import ImageSlider from '../../image-slider/image-slider';

const CarouselRender = (props) => {
  const {
    data, title, loading, onClick
  } = props;

  if (loading) {
    return <div className="text-center"><h2>Loading...</h2></div>;
  }

  return (
    !!data.length && (
      <ImageSlider
        data={data}
        title={title}
        rows={1}
        onClick={onClick}
      />
    )
  );
};

export default CarouselRender;
